import { render, staticRenderFns } from "./QueueIcon.vue?vue&type=template&id=65f1571d&scoped=true"
import script from "./QueueIcon.vue?vue&type=script&lang=js"
export * from "./QueueIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1571d",
  null
  
)

export default component.exports